import noop from 'lodash/noop'

export const SecureStorage = noop
